const SET_SEARCH_MODEL = 'SET_SEARCH_MODEL';
const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export default {
	namespaced: true,
	state: {
		searchModel: null,
		searchResults: null
	},
	actions: {
		setSearchModel({ commit }, searchModel) {
			commit(SET_SEARCH_MODEL, searchModel);
		},
		setSearchResults({ commit }, searchResults) {
			commit(SET_SEARCH_RESULTS, searchResults);
		}
	},
	mutations: {
		[SET_SEARCH_MODEL](state, searchModel) {
			state.searchModel = searchModel;
		},
		[SET_SEARCH_RESULTS](state, searchResults) {
			state.searchResults = searchResults;
		}
	}
};
